import { Injectable } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Injectable({
    providedIn: 'root'
})
export class ServicioAlertas {

    /**
     * Muestra una alerta al usuario.
     * @param titulo Título de la altera.
     * @param mensaje Mensaje del mensaje.
     * @param tipo Tipo de alerta.
     */
    public mostrar(titulo: string, mensaje: string = null, tipo: 'warning' | 'error' | 'success' | 'info' | 'question' = null) {

        let resultado: any; //Promise<SweetAlertResult>;

        if (mensaje !== undefined && tipo !== undefined)
            resultado = Swal.fire(titulo, mensaje, tipo);
        else if (mensaje !== undefined)
            resultado = Swal.fire(titulo, mensaje);
        else
            resultado = Swal.fire(titulo);

        return resultado;
    }

    /**
     * Muestra una alerta al usuario.
     * @param opciones Opciones de la alerta.
     */
    public mostrarConOpciones(opciones: any) {
        return Swal.fire(opciones);
    }

    /**
    * Se agrega método para poder leer inputs en sweetalert
    * @param opciones Opciones de la alerta.
    */
    public mostrarConOpcionesInput(opciones: any) {
        return Swal.fire(opciones); //true
    }
}